/* tslint:disable */
/* eslint-disable */
/**
 * Revisdom API
 * Revisdom uygulaması için REST API dokümantasyonu
 *
 * The version of the OpenAPI document: v1
 * Contact: support@revisdom.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * API yanıtları için genel response modeli
 * @export
 * @interface ApiResponse1String
 */
export interface ApiResponse1String {
    /**
     * İşlemin başarılı olup olmadığını belirtir
     * @type {boolean}
     * @memberof ApiResponse1String
     */
    success?: boolean;
    /**
     * İşlem sonucu hakkında bilgi mesajı
     * @type {string}
     * @memberof ApiResponse1String
     */
    message?: string | null;
    /**
     * Response data'sı
     * @type {string}
     * @memberof ApiResponse1String
     */
    data?: string | null;
    /**
     * Hata durumunda hata detayları
     * @type {{ [key: string]: Array<string>; }}
     * @memberof ApiResponse1String
     */
    errors?: { [key: string]: Array<string>; } | null;
}

/**
 * Check if a given object implements the ApiResponse1String interface.
 */
export function instanceOfApiResponse1String(value: object): value is ApiResponse1String {
    return true;
}

export function ApiResponse1StringFromJSON(json: any): ApiResponse1String {
    return ApiResponse1StringFromJSONTyped(json, false);
}

export function ApiResponse1StringFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResponse1String {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'] == null ? undefined : json['success'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : json['data'],
        'errors': json['errors'] == null ? undefined : json['errors'],
    };
}

export function ApiResponse1StringToJSON(json: any): ApiResponse1String {
    return ApiResponse1StringToJSONTyped(json, false);
}

export function ApiResponse1StringToJSONTyped(value?: ApiResponse1String | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'message': value['message'],
        'data': value['data'],
        'errors': value['errors'],
    };
}

